<template>
    <div>
        <Header></Header>
        <div class="top-message">
            <h1>{{userName}}さん<br>のマイページ</h1>
        </div>
        <div class="profile">
            <table border="1">
                <tbody>
                    <tr>
                        <th>ユーザ名</th>
                        <td>{{userName}}</td>
                    </tr>
                    <tr>
                        <th>学部学科</th>
                        <td>{{this.faculity}}</td>
                        
                    </tr>
                     <tr>
                        <th>学年</th>
                        <td>{{this.grade}}</td>
                    </tr>
                </tbody>
            </table>          
            <ul class="navigation">
                <li>
                    <div>
                        <router-link to="editProfile" @click.native="editProfile">
                            <img src="../assets/edit-24px.svg" alt="">
                            <p>プロフィール編集</p>
                        </router-link>
                    </div>
                </li>
                <li>
                    <div>
                        <router-link to="notifications">
                            <img src="../assets/notifications_none-24px.svg" alt="">
                            <p>おしらせ</p>
                        </router-link>
                    </div>
                </li>
                <li>
                    <div>
                        <router-link to="sellinglist">
                            <img src="../assets/photo_camera-24px.svg" alt="">
                            <p>出品した商品</p>
                        </router-link>
                    </div>
                </li>
                <li>
                    <div>
                        <router-link to="purchasedList">
                            <img src="../assets/work_outline-24px.svg" alt="">
                            <p>購入した商品</p>
                        </router-link>
                    </div>
                </li>
                <li>
                    <div>
                            <img src="../assets/favorite_border-24px.svg" alt="">
                            <p>いいね(未実装)</p>
                    </div>
                </li>
            </ul>
        </div>
        <Footer class="Footer"></Footer>
        <menu-bar class="menu-bar"></menu-bar>

    </div>
</template>

<script>
import Header from '../components/Header.vue'
import firebase from 'firebase'
import db from '../plugins/firestore'
import MenuBar from '../components/MenuBar.vue'
import Footer from '../components/Footer.vue'

export default {
    components: {Header, Footer,MenuBar},
    data(){
        return {
            user:'', //ユーザオブジェクト
            userName:'', // ユーザ名
            userID:'', //ユーザID
            profile:'', //ユーザのプロフィール（所属学部、学年、自己紹介が入る）
            faculity:'未設定',
            grade:'未設定',
            introduction:'未設定'
        }
    },
    created() {
      firebase.auth().onAuthStateChanged(user => {
        if(!user){
            this.$router.push({path: "/"})
        }else{
            this.user = user //ユーザオブジェクト
            this.userName = user.displayName
            this.userID = user.uid//ユーザID
            var self = this
            //ユーザのプロフィールをfirestoreから取得して、配列profileにfaculity,grade,introductionに突っ込む
            db.collection("users").doc(this.userID).get().then(function(doc){
                if(doc.exists){
                    self.faculity = doc.data().faculity
                    self.grade = doc.data().grade
                    // self.introduction = doc.data().introduction
                    self.profile = doc.data()
                }
            })
        }
      })
      
    },
    methods: {
        //商品画像がクリックされたら、vuexにデータを追加する。
        //item.itemIDが引数として渡されて、それをindex.jsのactionsにdispatchしている。
        selected(item){
            this.$store.dispatch('selected', item)
        },
        //プロフィール編集ボタンがクリックされたら、vuexにthis.userが渡される。
        editProfile(){
            this.$store.dispatch('editProfile', this.profile)
        }
    }
}
</script>

<style scoped>
.resultItems{
    margin-bottom: 50px;

}

.profile {
    margin-top: 20px;
    text-align: center;
}

.navigation p{
    font-size: 12px;
}

.navigation li{
    display: inline-block;
    margin-right: 15px;
    width: 100px;
}


.items {
    text-align: center;
}

table {
    margin: 25px auto;
    border-collapse:  collapse; /* セルの線を重ねる */
    width: 40%;
    border-color: rgb(220, 220, 220);
}
 
th{
    background-color: rgb(250, 250, 250);
    width: 25%;
}

th,td {
    padding: 5px 10px;          /* 余白指定 */
}

.Footer {
    position: absolute;
    bottom: 0;
}

@media all and (max-width:670px){
    h2 {
        font-size: 15px;
        padding: 15px 0px;
    }

    table {
        width: 90%;
    }

    th {
        width: 25%;
        font-size: 12px;
    }

    td {
        font-size: 13px;
    }
}
</style>
